const routes = [
  {
    name: "home",
    path: "/",
    description: "simple landing",
  },
  {
    name: "about",
    path: "/about",
    description: "who I am",
  },
  {
    name: "services",
    path: "/services",
    description: "what can I do",
  },
  {
    name: "portfolio",
    path: "/portfolio",
    description: "few projects",
  },
  {
    name: "contact",
    path: "/contact",
    description: "write to me",
  },
]

export default routes
